export default {"src":"/_next/static/media/RetinalDetachment.a13983e8.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};